import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap, map } from "rxjs";
import { MainService } from "../../../../app.service";
import { Project } from "../../interfaces/project";
import { Response } from "../../interfaces/response";

@Injectable({
  providedIn: "root",
})
export class DependencyTrackProjectsService {
  constructor(
    private httpClient: HttpClient,
    private mainsService: MainService
  ) { }

  getProjects(
    createdBy: string,
    productOwner: string,
    teams: Array<string>,
    name: string,
    status: string,
    page: number,
    limit: number,
    vulnerability: string = "",
    severity: string = "",
    componentName: string = "",
    componentVersion: string = ""
  ): Observable<Response<Project>> {

    // Monta params - sempre inclui page e limit
    const params: any = {
      page,
      limit,
    };
    
    if (createdBy) params.created_by = createdBy;
    if (productOwner) params.product_owner = productOwner;
    if (teams.length > 0) params.teams = teams;
    if (name) params.name = name;
    if (status !== null && status !== undefined && status !== '') {
      params.status = String(status);
    }
    if (vulnerability) params.vulnerability = vulnerability;
    if (severity) params.severity = severity;
    if (componentName) params.component_name = componentName;
    if (componentVersion) params.component_version = componentVersion;

    return this.httpClient.get<Response<Project>>(
      `/dependency-tracker-extractor/v1/projects`,
      {
        params,
        ...this.mainsService.httpOptions,
      }
    ).pipe(
      tap((response) => {
      }),
      map((response: any) => {
        if (Array.isArray(response)) {
          return {
            items: response,
            has_next: false,
            total: response.length
          } as Response<Project>;
        }
        if (response.items && response.items[0]?.project_id) {
          const mapped = {
            ...response,
            items: response.items.map((item: any) => ({
              ...item,
              id: item.project_id,
              name: item.project_name,         
              components: item.components,
              last_updated: item.last_updated
            }))
          };
          return mapped as unknown as Response<Project>;
        }
        return response;
      })
    );
  }

  postProjects(project: Project): Observable<Project> {
    return this.httpClient.post<Project>(
      `/dependency-tracker-extractor/v1/projects`,
      project,
      this.mainsService.httpOptions
    );
  }

  putProjects(project: Project): Observable<Project> {
    return this.httpClient.put<Project>(
      `/dependency-tracker-extractor/v1/projects/${project.id}`,
      project,
      this.mainsService.httpOptions
    );
  }

  deleteProjects(projectId: string, projectName: string): Observable<Project> {
    return this.httpClient.delete<Project>(
      `/dependency-tracker-extractor/v1/projects/${projectId}`,
      { ...this.mainsService.httpOptions, params: { projectName: projectName } }
    );
  }

  getProjectsCsv(projectId: string): Observable<Blob> {
    return this.httpClient.get(
      `/dependency-tracker-extractor/v1/projects/csv`,
      {
        params: {
          project_id: projectId,
        },
        responseType: "blob",
        ...this.mainsService.httpOptions,
      }
    );
  }

  postProjectsScan(projectId: string, project: Project): Observable<Project> {
    return this.httpClient.post<Project>(
      `/dependency-tracker-extractor/v1/projects/${projectId}/scan`,
      project,
      this.mainsService.httpOptions
    );
  }

  getProjectComponents(projectId: string): Observable<any> {
  return this.httpClient.get(
    `/dependency-tracker-extractor/v1/projects/${projectId}/components`,
    this.mainsService.httpOptions
  );
}
}
